// removed by extract-text-webpack-plugin
module.exports = {"root":"ItemBanner--root--3K","icon":"ItemBanner--icon--JB","body":"ItemBanner--body--2t","main":"ItemBanner--main--14","sub":"ItemBanner--sub--1Q","close":"ItemBanner--close--1B","exotic":"ItemBanner--exotic--UF","legendary":"ItemBanner--legendary--3u","rare":"ItemBanner--rare--33","common":"ItemBanner--common--3Y","basic":"ItemBanner--basic--21"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemBanner/styles.styl
// module id = 828
// module chunks = 0